import { memo, useEffect, useState, useRef } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import { Box, Flex, Stack, Text } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router";
import { HStack, Input, Center, AspectRatio, Button, Image, Table, Container, Wrap, Float, Drawer, CloseButton, Skeleton, SkeletonText, VStack } from "@chakra-ui/react"
import { LuSearch, LuShoppingCart, LuMessageCircle, LuCheck } from "react-icons/lu"
import { Heading } from "@chakra-ui/react"



import { Field } from "@/components/ui/field"
import Slider from "react-slick";
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"
import { PinInput } from "@/components/ui/pin-input"
import _ from "lodash"
import { useStore } from "contexts/store";
import BottomSheet from "components/bottom-sheet"
import moment from "moment";
import { FaCheck } from "react-icons/fa";

const ranges = [
    {
        name: "Hôm nay",
        start: moment().startOf("D"),
        end: moment().endOf("D"),


    },
    {
        name: "Hôm qua",
        start: moment().add(-1, "day").startOf("D"),
        end: moment().add(-1, "day").endOf("D"),
    },
    {
        name: "Tuần này",
        start: moment().startOf("W"),
        end: moment().endOf("D"),
    },
        {
        name: "Tuần trước",
        start: moment().add(-1, "week").startOf("W"),
        end: moment().add(-1, "week").endOf("W"),
    },
    {
        name: "Tháng này",
        start: moment().startOf("month"),
        end: moment().endOf("month"),
    },
    {
        name: "Tháng trước",
        start: moment().add(-1, "month").startOf("day"),
        end: moment().add(-1, "month").endOf("month"),
    },


]

const DateRangePicker = ({ onChange, value }) => {


    const [open, setOpen] = useState(false);
    const [selectRange, setSelectRange] = useState(ranges[0])
    useEffect(() => {
        if (value) {
            if (value.start) {
                var x = getRange(value);
                if (x) {
                    setSelectRange(x)
                } else {
                    setSelectRange({ name: "", start: value.start, end: value.end })
                }

            }
        }
    }, [value])


    const getRange = ({ start, end }) => {
        for (let index = 0; index < ranges.length; index++) {
            const element = ranges[index];

            if (moment(start).isSame(moment(element.start)) && moment(end).isSame(moment(element.end)))
                return element;

        }
    }






    const openPicker = () => {
        setOpen(true)
    }
    const onselect = (x) => {
        setSelectRange({ ...x })
        setOpen(false)
        if (onChange) {
            onChange({ start: x.start, end: x.end })
        }
    }

    const renderCheck = (x) => {
        if (moment(x.start).isSame(moment(selectRange.start)) && moment(x.end).isSame(moment(selectRange.end)))
            return <LuCheck></LuCheck>;
        return ""

    }


    return (
        <div>
            <Button size={"sm"} variant={"ghost"} onClick={openPicker}>{selectRange.name}</Button>
            <BottomSheet open={open} onOpenChange={(e) => setOpen(e.open)} title="Chọn thời gian">
                <Stack>
                    {ranges.map(x => {
                        return <Button variant={"outline"} onClick={e => onselect(x)} >
                            {renderCheck(x)}   {x.name}
                        </Button>
                    })}

                </Stack>

            </BottomSheet>



        </div>
    )
}

export default memo(DateRangePicker)